<template>
	<!-- Left Sidebar  -->
	<div class="left-sidebar">
		<!-- Sidebar scroll-->
		<div class="scroll-sidebar">
			<!-- Sidebar navigation-->
			<nav class="sidebar-nav">
				<ul id="sidebarnav" :style="'height:' + sidebarHeight + 'px'">
					<el-menu
							:default-openeds="openedMenu"
							class="el-menu-vertical"
							:collapse="isCollapse">
						<template v-for="(item, index) in navItems">
							<el-sub-menu v-if="item.name && item.children && AccessAllowed(item,'0')" :index="index.toString()">
								<template #title>
									<i :class="item.icon"></i>
									<span>{{item.name}}</span>
								</template>
                                <template v-for="( childL1, index2 ) in item.children">
									<router-link :to="childL1.url" exact>
                                    	<el-menu-item @click="menuClicked" v-if="AccessAllowed(childL1,index)"  :index="index+'-'+index2" :key="index+'-'+index2">
                                            <i :class="childL1.icon"></i>
                                            <span>{{childL1.name}}</span>
										</el-menu-item>
									</router-link>
                                </template>
							</el-sub-menu>
							<router-link v-else-if="item.name && AccessAllowed(item, '0')" :to="item.url" exact>
								<el-menu-item @click="menuClicked"  :index="index.toString()">
									<i :class="item.icon"></i>
									<span>{{item.name}}</span>
							</el-menu-item>
						</router-link>
						</template>
					</el-menu>
				</ul>
			</nav>
			<!-- End Sidebar navigation -->
		</div>
		<!-- End Sidebar scroll-->
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Util from '../../assets/js/util.js';

	export default {
		data (){
			return {
				openedMenu : ["2","3","4"],
				unqiue : true,
				urlPath : '',
				sidebarHeight: 600
			}
		},
		name: 'sidebar',
		props: {
			navItems: {
				type: Array,
				required: true,
				default: () => []
			},
			isCollapse: {
				type: Boolean,
				required: true,
				default: false
			},
			config: {
				type: Object,
				required: true,
				default: () => {}
			},
			height: {
				type: Number,
				required: true,
				default: 600
			},
		},
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
		},
		watch: {
			height: {
				handler(newVal, oldVal) {
					this.sidebarHeight =  newVal - 57;
				},
				deep: true
			},
		},
		methods: {
			AccessAllowed (item, index) {
				var access = false;
				if (item.children) {
					//need to have access to at least one child or no access to dropdown
					for (let j=0; j < item.children.length; j++) {
						var fullPath = item.children[j].url.substr(1).split('/');
						if (item.children[j].security) {
							for (let i=0; i < this.currentUser.RoleSecurity.length; i++) {
								if (this.currentUser.RoleSecurity[i].Params) {
									if (this.currentUser.RoleSecurity[i].SecurityAreaCode == fullPath[0]) {
										if ((this.currentUser.RoleSecurity[i].Params.Access && this.currentUser.RoleSecurity[i].Params.Access == 'true') || this.currentUser.RoleSecurity[i].Params.ReadAccess) {
											access = true;
											break;
										}
									}
								}
							}
						} else {
							access = true;
						}
					}
				} else {
					if (item.security) {
						var fullPath = item.url.substr(1).split('/');
						if (this.urlPath == item.url.substr(1)) {
							if (this.openedMenu.length == 0) {
								//this.openedMenu = [index.toString()];
								this.urlPath = '';
							}
						}
						for (let i = 0; i < this.currentUser.RoleSecurity.length; i++) {
							if (this.currentUser.RoleSecurity[i].Params) {
								if (this.currentUser.RoleSecurity[i].SecurityAreaCode == fullPath[0]) {
									if ((this.currentUser.RoleSecurity[i].Params.Access && this.currentUser.RoleSecurity[i].Params.Access == 'true') || this.currentUser.RoleSecurity[i].Params.ReadAccess) {
										access = true;
										break;
									}
								}
							}
						}
					} else {
						access = true;
					}
				}
				return access;
			},
			menuClicked(menu) {
				if (Util.isMobile()) {
					document.body.classList.toggle('mini-sidebar');
					let collapse = document.body.classList.contains('mini-sidebar');
					this.$emit('collapse', {isCollapse: collapse});
				}
			}
		},
		mounted() {
			this.sidebarHeight = this.height - 57;
			this.urlPath = this.$route.fullPath.substr(1);
			//if the last path piece is numeric, get rid of it
			let urlParts = this.urlPath.split('/');
			if (!isNaN(urlParts[urlParts.length-1])) {
				urlParts.splice(-1,1);
				this.urlPath = urlParts.join('/');
			}
		}
	}


</script>

<style scoped>
	#sidebarnav {
		overflow-y:scroll;
		height: auto;
	}
	.el-menu {
		border-right: 0;
		overflow-x: hidden;
	}
	/* Collapsed rail: icons only, centered, no text (ported from valley) */
	.el-menu-vertical.el-menu--collapse span {
		height: 0;
		width: 0;
		overflow: hidden;
		visibility: hidden;
		display: inline-block;
	}
	#sidebarnav ul.el-menu--vertical.el-menu--collapse {
		padding-left: 10px;
	}
	.el-menu-item a {
		display:inline-block;
		width:100%;
		height:100%;
	}
	.el-menu-item {
		padding-right: 0px;
	}
	.scroll-sidebar {
		margin-bottom: 5px;
		padding-bottom: 0px;
	}
</style>

<!--
	Dark-navy sidebar theme, ported from valley-analyzer-v3's design system.
	Kept as its own :root token block (single hardcoded palette per plan) rather
	than porting valley's Settings-driven multi-color theming.
-->
<style>
:root {
	--va-nav-bg:            #0D1B2A;
	--va-nav-text:          #94A3B8;
	--va-nav-hover-bg:      rgba(255,255,255,0.07);
	--va-nav-hover-text:    #FFFFFF;
	--va-nav-active-bg:     rgba(63,156,168,0.16);
	--va-nav-active-accent: #3F9CA8;
	--va-nav-active-text:   #82BFC6;
	--va-nav-separator:     rgba(255,255,255,0.08);
	--va-nav-indent-line:   rgba(255,255,255,0.10);
}

/* ── Sidebar container background ────────────────────────── */
.left-sidebar {
	background-color: var(--va-nav-bg) !important;
}

/* ── El-menu base: match sidebar bg, no border ───────────── */
#sidebarnav .el-menu,
#sidebarnav .el-sub-menu .el-menu {
	background-color: var(--va-nav-bg) !important;
	border-right: none !important;
}

/* ── All item text and icons: base nav text color ─────────── */
#sidebarnav .el-menu-item,
#sidebarnav .el-menu-item i,
#sidebarnav .el-menu-item span,
#sidebarnav .el-sub-menu__title,
#sidebarnav .el-sub-menu__title i,
#sidebarnav .el-sub-menu__title span {
	color: var(--va-nav-text) !important;
	transition: color 0.12s, background-color 0.12s;
}

/* ── Sub-menu group headers ───────────────────────────────── */
#sidebarnav div.el-sub-menu__title {
	height: 38px;
	line-height: 38px;
	border-bottom: 1px solid var(--va-nav-separator);
	font-size: 12.5px;
	font-weight: 500;
	letter-spacing: 0.01em;
}

/* ── Hover — tinted bg + full-contrast text ────────────────  */
#sidebarnav .el-menu-item:hover {
	background-color: var(--va-nav-hover-bg) !important;
	color: var(--va-nav-hover-text) !important;
}
#sidebarnav .el-sub-menu__title:hover {
	background-color: var(--va-nav-hover-bg) !important;
	color: var(--va-nav-hover-text) !important;
}
#sidebarnav .el-menu-item:hover i,
#sidebarnav .el-menu-item:hover span,
#sidebarnav .el-sub-menu__title:hover i,
#sidebarnav .el-sub-menu__title:hover span {
	color: var(--va-nav-hover-text) !important;
}

/* ── Active item — tinted bg + left accent bar ────────────── */
#sidebarnav li.el-menu-item.is-active,
#sidebarnav .router-link-active li.el-menu-item {
	background-color: var(--va-nav-active-bg) !important;
	border-left: 3px solid var(--va-nav-active-accent) !important;
	border-radius: 0 !important;
}
/* Shift content right to compensate for the 3px border */
#sidebarnav li.el-menu-item.is-active .el-menu-item {
	padding-left: calc(var(--el-menu-base-level-padding, 10px) - 3px) !important;
}

/* Active text and icons: derived accent color */
#sidebarnav li.el-menu-item.is-active,
#sidebarnav li.el-menu-item.is-active i,
#sidebarnav li.el-menu-item.is-active span,
#sidebarnav .router-link-active li.el-menu-item,
#sidebarnav .router-link-active li.el-menu-item i,
#sidebarnav .router-link-active li.el-menu-item span {
	color: var(--va-nav-active-text) !important;
	font-weight: 500;
}

/* ── Open sub-menu group: subtle bottom border ────────────── */
#sidebarnav .el-sub-menu.is-opened {
	border-bottom: 1px solid var(--va-nav-separator);
}

/* ── Child item indent line ───────────────────────────────── */
#sidebarnav .el-menu--inline {
	border-left: 2px solid var(--va-nav-indent-line);
	margin-left: 14px;
}

/* ── Menu item links ──────────────────────────────────────── */
#sidebarnav .el-menu--vertical ul li a {
	padding: 0;
	display: flex;
	align-items: center;
	width: 100%;
	height: 100%;
}

/* ── Collapsed-mode native flyout popups: theme + size-to-content ── */
.el-menu--popup {
	min-width: 200px;
	width: max-content;
	max-width: 420px;
	background-color: var(--va-nav-bg) !important;
}
.el-menu--popup .el-menu-item,
.el-menu--popup .el-sub-menu__title { white-space: nowrap; }

/* Flyout popups are teleported outside #sidebarnav in the DOM, so the
   #sidebarnav-scoped text rules above never reach them -- restate here. */
.el-menu--popup .el-menu-item,
.el-menu--popup .el-menu-item i,
.el-menu--popup .el-menu-item span,
.el-menu--popup .el-sub-menu__title,
.el-menu--popup .el-sub-menu__title i,
.el-menu--popup .el-sub-menu__title span {
	color: var(--va-nav-text) !important;
}
.el-menu--popup .el-menu-item:hover,
.el-menu--popup .el-sub-menu__title:hover {
	background-color: var(--va-nav-hover-bg) !important;
	color: var(--va-nav-hover-text) !important;
}
.el-menu--popup .el-menu-item:hover i,
.el-menu--popup .el-menu-item:hover span,
.el-menu--popup .el-sub-menu__title:hover i,
.el-menu--popup .el-sub-menu__title:hover span {
	color: var(--va-nav-hover-text) !important;
}
.el-menu--popup li.el-menu-item.is-active,
.el-menu--popup li.el-menu-item.is-active i,
.el-menu--popup li.el-menu-item.is-active span,
.el-menu--popup .router-link-active li.el-menu-item,
.el-menu--popup .router-link-active li.el-menu-item i,
.el-menu--popup .router-link-active li.el-menu-item span {
	color: var(--va-nav-active-text) !important;
	font-weight: 500;
}
</style>
